module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar"
  }, [_c('transition', {
    attrs: {
      "name": "openTray"
    },
    on: {
      "before-enter": _vm.onAnimationStart,
      "after-enter": _vm.onAnimationEnd
    }
  }, [(_vm.isBottomTrayVisible) ? _c('bottomtray', {
    attrs: {
      "presentation": _vm.presentation,
      "person": _vm.person,
      "user": _vm.user,
      "trayType": _vm.trayContent,
      "chatContacts": _vm.chatContacts,
      "chatList": _vm.chatList,
      "presentationList": _vm.presentationList,
      "isLoading": _vm.isLoading,
      "peopleList": _vm.peopleList,
      "questionList": _vm.questionList,
      "peopleMap": _vm.peopleMap
    },
    on: {
      "closeTray": _vm.closeTray
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayContent === 'Notes') ? _c('notestray', {
    attrs: {
      "currentSlide": _vm.currentSlide,
      "presentation": _vm.presentation,
      "slideList": _vm.slideList,
      "user": _vm.user
    },
    on: {
      "closeTray": _vm.closeTray
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "bottom-menu"
  }, [_c('li', {
    attrs: {
      "disabled": !_vm.isAllowedToListSessions
    },
    on: {
      "click": _vm.openSessions
    }
  }, [(_vm.trayContent === 'Sessions') ? _c('img', {
    attrs: {
      "src": require("../assets/icons/sessions_selected.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icons/sessions_unselected.svg")
    }
  })]), _vm._v(" "), (this.presentation) ? _c('li', {
    on: {
      "click": _vm.openQuestions
    }
  }, [_c('div', [(_vm.trayContent === 'Questions') ? _c('img', {
    attrs: {
      "src": require("../assets/icons/questions_selected.svg")
    }
  }) : _c('img', {
    class: {
      notify: _vm.newQuestion
    },
    attrs: {
      "src": require("../assets/icons/questions_unselected.svg")
    }
  }), _vm._v(" "), (_vm.newQuestion) ? _c('div', {
    staticClass: "notification-bubble"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.presentation) ? _c('li', {
    on: {
      "click": _vm.openPeople
    }
  }, [_c('div', [(_vm.trayContent === 'People') ? _c('img', {
    attrs: {
      "src": require("../assets/icons/people_selected.svg")
    }
  }) : _c('img', {
    class: {
      notify: _vm.newPerson
    },
    attrs: {
      "src": require("../assets/icons/people_unselected.svg")
    }
  }), _vm._v(" "), (_vm.newPerson) ? _c('div', {
    staticClass: "notification-bubble"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.presentation) ? _c('li', {
    class: _vm.trayContent === 'Chat' ? 'selected' : '',
    on: {
      "click": _vm.openChat
    }
  }, [(_vm.trayContent === 'Chat') ? _c('img', {
    attrs: {
      "src": require("../assets/icons/chat_selected.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icons/chat_unselected.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (this.presentation) ? _c('li', {
    on: {
      "click": _vm.openNotes
    }
  }, [(_vm.trayContent === 'Notes') ? _c('img', {
    attrs: {
      "src": require("../assets/icons/notes_selected.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icons/notes_unselected.svg")
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac7537a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomBar.vue
// module id = 490
// module chunks = 0